"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Task = void 0;
exports.taskRequestTransformer = taskRequestTransformer;
var time_1 = require("../common/helpers/time");
var Task = /** @class */ (function () {
    function Task(data) {
        this.$originalData = data;
        var id = data.id, created_by = data.created_by, complete = data.complete, due_on = data.due_on, name = data.name, details = data.details, school_id = data.school_id, organisation_id = data.organisation_id, created_at = data.created_at, updated_at = data.updated_at, users = data.users, owner = data.owner, style = data.style;
        this.$id = id;
        this.$created_by = created_by;
        this.$complete = complete;
        this.$due_on = due_on;
        this.$name = name;
        this.$details = details;
        this.$school_id = school_id;
        this.$organisation_id = organisation_id;
        this.$created_at = created_at;
        this.$updated_at = updated_at;
        this.$timestamp = (0, time_1.getUnixTimestamp)((0, time_1.dateTimeStringToDate)(due_on));
        this.$users = users;
        this.$owner = owner;
        this.$style = style;
    }
    Task.prototype.assignOwner = function (id) {
        this.$created_by = id;
    };
    return Task;
}());
exports.Task = Task;
/**
 * transform task class for backend requests
 */
function taskRequestTransformer(task) {
    var $task = {
        id: task.$id,
        created_by: task.$created_by,
        complete: task.$complete,
        due_on: task.$due_on,
        name: task.$name,
        details: task.$details,
        school_id: task.$school_id,
        organisation_id: task.$organisation_id,
        created_at: task.$created_at,
        updated_at: task.$updated_at,
        users: task.$users,
        owner: task.$owner,
        style: task.$style,
    };
    return $task;
}
